import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { get, put, post } from '../../utils/apiUtils';
import { motion } from 'framer-motion';
import CommonHexagonBadge from './CommonHexagonBadge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear, faPeopleGroup, faBell, faRobot, faPlug, faPlus } from '@fortawesome/free-solid-svg-icons';
import { faBuilding, faCircleDown } from '@fortawesome/free-regular-svg-icons';
import {
  FormRow,
  FormGroup, Label, Input, Select, Button, ButtonGroup, SectionTitle,
  Modal, ModalContent, ModalHeader, CloseButton, Divider,Card,CardTitle,ButtonSuccess
} from '../../styles/PageStyles';
import { updateUserGroup } from '../../services/groupService';

const Toggle = styled.div`
  position: relative;
  display: inline-block;
  width: 50px;
  height: 26px;
`;

const ToggleInput = styled.input`
  opacity: 1;
  width: 20px;
  height: 20px;
  
  &:checked + span {
    background: var(--gradient-primary);
  }
  
  &:checked + span:before {
    transform: translateX(24px);
  }
`;


const UserGroups = ({ onSelectGroup }) => {
    const [userGroupsList, setUserGroupsList] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const fetchUserGroups = async () => {
            try {
                const response = await get('/api/v1/mms_persistence/user_group');
                setUserGroupsList(response);
            } catch (error) {
                console.error('Error fetching user groups:', error);
                navigate('/login');
            }
        };

        fetchUserGroups();
    }, [navigate]);

    const handleToggleChange = async (group) => {
        group.status = group.status === "ACTIVE" ? "INACTIVE" : "ACTIVE";
        updateGroup(group)
    };
    const updateGroup = async (group) => {
        try {
            // Call API to update group status
            // const reponse = await put(`${PERSISTANCE}/user_group`, JSON.stringify(group));
            const response = await updateUserGroup(group)

            //Update the local state
            setUserGroupsList((prevGroups) =>
                prevGroups.map((g) =>
                    g.id === group.id ? { ...g, status: response.status } : g
                )
            );
        } catch (error) {
            console.error('Error updating group status:', error);
        }
    };

    const filteredGroups = userGroupsList.filter((group) =>
        group.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    return (
        <>
            <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                <SectionTitle>User Groups</SectionTitle>
                <div style={{ marginLeft: 'auto', display: 'flex', gap: '2px', alignItems: 'center' }}>
                    <Input type="text" placeholder="Search groups..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <ButtonSuccess onClick={() => onSelectGroup(null)}><FontAwesomeIcon icon={faPlus} /> Group</ButtonSuccess>
                </div>
            </div>
            <Divider />
            <ul>
                {filteredGroups.map((group) => (
                    <Card key={group.id}>
                        <CardTitle>
                            <CommonHexagonBadge
                                stroke="stroke-brand-clarity"
                                fill="fill-brand-light"
                                size="size-[50px]"
                                badge={faBuilding}
                                onClick={() => onSelectGroup(group)} style={{ cursor: 'pointer' }}
                            />
                            <div onClick={() => onSelectGroup(group)} style={{ cursor: 'pointer' }}>
                                <h5>{group.name}</h5>
                                <p>{group.description}</p>
                            </div>
                            <div style={{ marginLeft: 'auto', display: 'flex', gap: '1rem', alignItems: 'center' }}>
                                <Toggle>
                                    <ToggleInput
                                        type="checkbox"
                                        checked={group.status === "ACTIVE"}
                                        onChange={async () => {
                                            await handleToggleChange(group);
                                        }}
                                    />
                                </Toggle>
                            </div>
                        </CardTitle>
                    </Card>
                ))}
            </ul>
        </>
    )
}

export default UserGroups;